module.exports = __webpack_public_path__ + "static/media/zoom-plus.57c1a77d.svg";